export default "__VITE_ASSET__BKjCElJQ__"